import type { AxiosRequestConfig } from "axios"
import { useMemo } from "react"

// this is the key for the cached device settings data
export function useDeviceSettingsSWRKey(): AxiosRequestConfig | undefined {
  const swrKey = useMemo(
    () => {
      const url = "/api/v3/device_settings"

      return {
        url,
      }
    },
    [],
  )

  return swrKey
}
